import { Converter } from '../types/converter';

export const radiationConverter: Converter = {
  id: 'radiation',
  name: 'Radiation Converter',
  icon: 'Radio',
  categories: ['radiology'],
  units: [
    // SI unit and prefixes
    { name: 'Gray/second', symbol: 'Gy/s', factor: 1 },
    { name: 'Exagray/second', symbol: 'EGy/s', factor: 1e18 },
    { name: 'Petagray/second', symbol: 'PGy/s', factor: 1e15 },
    { name: 'Teragray/second', symbol: 'TGy/s', factor: 1e12 },
    { name: 'Gigagray/second', symbol: 'GGy/s', factor: 1e9 },
    { name: 'Megagray/second', symbol: 'MGy/s', factor: 1e6 },
    { name: 'Kilogray/second', symbol: 'kGy/s', factor: 1e3 },
    { name: 'Hectogray/second', symbol: 'hGy/s', factor: 1e2 },
    { name: 'Dekagray/second', symbol: 'daGy/s', factor: 10 },
    { name: 'Decigray/second', symbol: 'dGy/s', factor: 0.1 },
    { name: 'Centigray/second', symbol: 'cGy/s', factor: 0.01 },
    { name: 'Milligray/second', symbol: 'mGy/s', factor: 1e-3 },
    { name: 'Microgray/second', symbol: 'µGy/s', factor: 1e-6 },
    { name: 'Nanogray/second', symbol: 'nGy/s', factor: 1e-9 },
    { name: 'Picogray/second', symbol: 'pGy/s', factor: 1e-12 },
    { name: 'Femtogray/second', symbol: 'fGy/s', factor: 1e-15 },
    { name: 'Attogray/second', symbol: 'aGy/s', factor: 1e-18 },
    
    // Traditional units
    { name: 'Rad/second', symbol: 'rad/s', factor: 0.01 },
    
    // Energy-based units
    { name: 'Joule/kilogram/second', symbol: 'J/kg/s', factor: 1 },
    { name: 'Watt/kilogram', symbol: 'W/kg', factor: 1 },
    
    // Biological effect units
    { name: 'Sievert/second', symbol: 'Sv/s', factor: 1 },
    { name: 'Rem/second', symbol: 'rem/s', factor: 0.01 }
  ]
};
